const actionTypes = {
  SET_DETAIL: 'setDetail',
  GET_CARTS_COUNT: 'getCartsCount',
  DISBLE_SEND: 'disable_send',
  UNKNOW_CORPORATE: 'unknow_corporate',
  UNKNOW_USER: 'unknow_user',
  SET_RECIPIENT_OPTIONS: 'setRecipientOptions',
  SET_SIDEBAR_CLICK: 'sideBarClick',
  SET_TRANSACTIONS: 'setTransactions',
  SET_ALLOW_MOVE_TO_CONFIRM_VIEW: 'sendCartSetAllowMoveToConfirmView',
  SET_SENDABLE_STATUS: 'sendCart/setSandableStatus',
  SET_SENDABLE_CHECKED_MESSAGE: 'sendCart/setSandableCheckedMessage',
}

export default actionTypes
